import { trackChatbarPersonalization } from "../services/analytics";

// Define personalization question types for analytics
export type PersonalizationEventType = 'intro' | 'fam' | 'colour' | 'theme' | 'type' | 'managed' | 'procho';

// Map keywords to event types for analytics tracking
const keywordToEventType: Record<string, PersonalizationEventType> = {
  "Hello and welcome! I'm your personalised NDIS assistant,": 'intro',
  "what would you like to call me": 'fam',
  "Would you like to adjust the chat colour": 'theme',
  "which best describes you": 'type',
  "How is your NDIS plan currently managed?": 'managed',
  "Who is your NDIS plan manager?": 'procho'
};

export const predefinedResponses: { keyword: string; responses: string[] }[] = [
    {
      keyword: "Show this to get a free coffee!",
      responses: ["I'm ready to chat"],
    },
    {
      keyword: "Would you like to continue as a guest or log in?",
      responses: ["Start Chatting", "Log In for Personalised Support"],
    },
    {
      keyword: "Would you like to adjust the chat colour",
      responses: ["Done."],
    },
    {
      keyword: "Which of these best describes you",
      responses: ["I'm caring for someone", "I need support myself", "I'm a provider or coordinator", "Just exploring / other"],
    },
  ];
  
  export const getPredefinedResponses = (lastMessage: string | undefined): string[] => {
    if (!lastMessage) return [];
  
    const foundResponse = predefinedResponses.find(({ keyword }) => lastMessage.toLowerCase().includes(keyword.toLowerCase()));
  
    return foundResponse ? foundResponse.responses : [];
  };
  
  // Helper to track predefined responses with specific analytics per the tagging plan
  export const trackPredefinedResponseWithAnalytics = (question: string, response: string): void => {
    // Find the matching event type for this question
    for (const [keyword, eventType] of Object.entries(keywordToEventType)) {
      if (question.toLowerCase().includes(keyword.toLowerCase())) {
        // Special handling for "Done." response on theme selection
        if (eventType === 'theme' && response === 'Done.') {
          // Track the current theme that was selected
          // We need to retrieve the current theme from localStorage or another source
          const currentTheme = localStorage.getItem('layoutMode') || 'light';
          
          // Now track the theme selection when user confirms with "Done."
          trackChatbarPersonalization('theme', currentTheme);
          break;
        }
        
        // Track with the specific event format from the tagging plan for other events
        trackChatbarPersonalization(eventType, response);
        break;
      }
    }
  };
  